import useTracksStore, {
  type TrackType,
} from '../../../../shared/store/tracks.store.tsx'
import type { Clip } from '../models/clip.ts'

export const addDraggingClip = (
  type: TrackType,
  id: string,
  name: string,
  tmpDuration: number
): Clip => {
  const { setDraggedClip } = useTracksStore.getState()
  const clipID = crypto.randomUUID()

  const clip: Clip = {
    id: clipID,
    type,
    trackId: 'tmp',
    name,
    startAt: undefined,
    startOffset: 0,
    duration: tmpDuration,
    endOffset: 0,
    mediaId: id,
    fadeIn: 0,
    fadeOut: 0,
    lastPosition: undefined,
  }

  setDraggedClip(clip)
  return clip
}
